import PropTypes from "prop-types";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { visionURL } from "../../config/environment";
import {
  Box,
  Button,
  FormControlLabel,
  Typography,
  Checkbox
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import { updateUserSettings } from "../../services/temporaryVisionCallService";

// TODO: Add spanish translations below
const haveReadTocMsg = {
  es: "I have read the above Terms and Conditions",
  en: "I have read the above Terms and Conditions"
};

const acceptBtnText = {
  es: "Accept",
  en: "Accept"
};

const declineBtnText = {
  es: "Decline",
  en: "Decline"
};

const useStyles = makeStyles(theme => ({
  button: {
    marginRight: theme.spacing(2)
  }
}));

const TermsAndConditionsContent = ({ language }) => {
  const classes = useStyles();
  const theme = useTheme();
  const [termsRead, setTermsRead] = useState(false);
  const user = useSelector(state => state.userState.user);

  const termsAndConditions = useSelector(({ customerState: { customer } }) => {
    return {
      en: customer.termsAndConditions
        ? customer.termsAndConditions.find(terms => terms.language === "en")
        : null,
      es: customer.termsAndConditions
        ? customer.termsAndConditions.find(terms => terms.language === "es")
        : null
    };
  });

  const tocContent = [
    {
      key: "en",
      content: termsAndConditions.en ? termsAndConditions.en.tcText : ""
    },
    {
      key: "es",
      content: termsAndConditions.es ? termsAndConditions.es.tcText : ""
    }
  ];

  const selectedLangContent = tocContent.filter(({ key }) => key === language);

  const handleTermsAccepted = async () => {
    await updateUserSettings(user.id, {
      tc_accepted: termsAndConditions[language].id
    });
    window.location = window.location;
  };

  const handleTermsDeclined = () => {
    window.location = `${visionURL}/users/sign_out`;
  };

  return (
    <Box display="flex" flexDirection="column">
      <Box mb={2.5} color={theme.palette.text.secondary}>
        {selectedLangContent.map((terms, key) => (
          <div key={key} dangerouslySetInnerHTML={{ __html: terms.content }} />
        ))}
      </Box>
      <Box mb={2.5} mt={1}>
        <FormControlLabel
          control={
            <Checkbox
              checked={termsRead}
              color="primary"
              onChange={({ target: { checked } }) => setTermsRead(checked)}
            />
          }
          label={
            <Typography variant="subtitle1" color="textSecondary">
              {haveReadTocMsg[language]}
            </Typography>
          }
        />
      </Box>
      <Box display="flex" mt={2.5} mb={12}>
        <Button
          className={classes.button}
          variant="contained"
          color="primary"
          disabled={!termsRead}
          onClick={() => handleTermsAccepted()}
        >
          {acceptBtnText[language]}
        </Button>
        <Button
          className={classes.button}
          color="primary"
          onClick={() => handleTermsDeclined()}
        >
          {declineBtnText[language]}
        </Button>
      </Box>
    </Box>
  );
};

TermsAndConditionsContent.propTypes = {
  location: PropTypes.object
};

export default TermsAndConditionsContent;
